import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return <section className="px-4 py-16 bg-brand-surface" data-id="element-61">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-62">
        {/* YES Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#111] p-8 rounded-xl border border-green-900/30 shadow-lg" data-id="element-63">
          <h3 className="font-display text-3xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-64">
            <span className="bg-green-500/20 p-2 rounded text-green-500" data-id="element-65">
              <Check size={24} strokeWidth={3} data-id="element-66" />
            </span>
            Esto es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-67">
            {["Necesitas ingreso extra ya (no 'algún día').", 'Te sientes perdido/a y abrumado/a con tanta información.', 'Tienes poco tiempo (trabajo, familia, estrés).', 'Te da pena cobrar o no sabes qué decir.', 'No quieres un curso largo: quieres pasos.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-68">
                <Check className="text-green-500 shrink-0 mt-1" size={18} data-id="element-69" />
                <span data-id="element-70">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* NO Column */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-[#111] p-8 rounded-xl border border-red-900/30 shadow-lg" data-id="element-71">
          <h3 className="font-display text-3xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-72">
            <span className="bg-red-500/20 p-2 rounded text-red-500" data-id="element-73">
              <X size={24} strokeWidth={3} data-id="element-74" />
            </span>
            Esto NO es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-75">
            {['Buscas hacerte rico sin hacer nada.', "Quieres 'inspiración' pero no vas a publicar/ofrecer.", 'No estás dispuesto/a a ejecutar 30–60 minutos al día por 7 días.', 'Esperas resultados mágicos sin seguir el plan.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-76">
                <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-77" />
                <span data-id="element-78">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}